import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { IdDescription } from 'tms-lib';
import { BaseReferenceService } from './base';

@Injectable({
  providedIn: 'root',
})
export class PickListPalletReferenceService extends BaseReferenceService {
  constructor() {
    super('PickListPalletReference');
  }

  // Pallets belong to one transfer, so this is the call the workbench dropdowns use.
  getForTransfer(id: string): Observable<IdDescription[]> {
    return this.httpService.get<IdDescription[]>(`${this.apiUrl}/GetForTransfer/${id}`);
  }
}
